export default __webpack_public_path__ + "static/media/KBM04555.5cbfc650.webp";